module.exports = __webpack_public_path__ + "img/santolaya.5c7fb4c2.svg";